import { createContext, useContext } from "react";

import type { UpdateInteractModule } from "@skilitics/nautilus-endpoint-definition";

export type DuplicateModuleSettings = Pick<UpdateInteractModule, "title">;

type DuplicateModuleSettingsContext = DuplicateModuleSettings & {
  setTitle: (title: string) => void;

  reset: () => void;
};

export const DuplicateModuleSettingsContext = createContext<DuplicateModuleSettingsContext | undefined>(undefined);

export const useDuplicateModuleSettings = (): DuplicateModuleSettingsContext => {
  const context = useContext(DuplicateModuleSettingsContext);

  if (!context) throw new Error(`Expected DuplicateModuleSettingsContext in ancestor tree.`);

  return context;
};

DuplicateModuleSettingsContext.displayName = "DuplicateModuleSettingsContext";
